import { useIsFeatureEnabled } from '@databases/utils/hooks/useIsFeatureEnabled';
import { getExperimentValue } from '@canvas/client-feature-flags/experiments';
import {
  PaywallFeature,
  useHasPaywallFeatureStateResolved,
  useIsPaywallUnlocked
} from '@canvas/paywall';

interface UseIsAiSummaryFieldEnabledOptions {
  fireExperimentExposure?: boolean;
}

export const useIsAiSummaryFieldEnabled = ({
  fireExperimentExposure = false
}: UseIsAiSummaryFieldEnabledOptions = {}) => {
  const isDbAiFirstCreationEnabled = useIsFeatureEnabled('dbAiFirstCreation');
  const hasPaywallFeatureStateResolved = useHasPaywallFeatureStateResolved();
  const isAiTeammatePaywallUnlocked = useIsPaywallUnlocked(PaywallFeature.AI_TEAMMATE);

  return (
    isDbAiFirstCreationEnabled &&
    hasPaywallFeatureStateResolved &&
    isAiTeammatePaywallUnlocked &&
    getExperimentValue('databasesFrontendAiFieldsSummary', 'enabled', {
      fireExperimentExposure
    })
  );
};
